import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { cn } from '@/frontend/utils';
export const P2 = t0 => {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("text-base text-contentSecondary leading-7 lg:text-lg", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <p className={t1}>{children}</p>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};